"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateSubscriptionOnCancelOrRenew = exports.CANCEL_SUBSCRIPTION = void 0;
const client_1 = require("@apollo/client");
const restricted_1 = require("../../query/restricted");
exports.CANCEL_SUBSCRIPTION = (0, client_1.gql) `
  mutation CancelSubscription(
    $subscriptionId: Int!
    $comment: String
    $feedback: String
  ) {
    restricted {
      cancelSubscription(
        subscriptionId: $subscriptionId
        comment: $comment
        feedback: $feedback
      ) {
        id
        endedAt
        periodEndAt
        stripeSubscriptionId
        userId
        productId
      }
    }
  }
`;
const updateSubscriptionOnCancelOrRenew = (cache, result, options) => {
    const { cancelSubscription } = result?.data?.restricted || {};
    const { variables } = options || {};
    if (!variables || !cancelSubscription) {
        return;
    }
    const prevData = cache.readQuery({
        query: restricted_1.USER,
    });
    if (!prevData) {
        return;
    }
    const { subscriptionId } = variables;
    const { subscriptions } = prevData.restricted.user;
    prevData.restricted.user.subscriptions = subscriptions.map((s) => Number(s.id) === Number(subscriptionId)
        ? { ...s, ...cancelSubscription }
        : s);
    cache.writeQuery({ query: restricted_1.USER, data: { ...prevData } });
};
exports.updateSubscriptionOnCancelOrRenew = updateSubscriptionOnCancelOrRenew;
